/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Hamburger/theme';

export const HamburgerTheme = theme;
